import React, { useContext, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { TextField, Button, Typography, Alert } from "@mui/material";
import { AuthContext } from "utils/context/authContext";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SignInForm = ({ from }) => {
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm();
  const { handleLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState(null);

  const onSubmit = async (data) => {
    const result = await handleLogin(data);
    if (result.success) {
      const redirectPath = from ? from.pathname + from.search : "/messages";
      navigate(redirectPath, { replace: true });
    } else {
      setLoginError(result.message);
    }
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        {t("decisionVueMessageCenter")}
      </Typography>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ width: "100%", marginTop: 16 }}
      >
        <Controller
          name="username"
          control={control}
          defaultValue=""
          rules={{
            required: {
              value: true,
              message: t('please_fill_out_this_field'),
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label={t('username')}
              variant="outlined"
              margin="normal"
              fullWidth
              required
            />
          )}
        />
        <Controller
          name="password"
          control={control}
          defaultValue=""
          rules={{
            required: {
              value: true,
              message: t('please_fill_out_this_field'),
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label={t('Password')}
              type="password"
              variant="outlined"
              margin="normal"
              fullWidth
              required
            />
          )}
        />
        {loginError && (
          <Alert severity="error" style={{ marginTop: 16 }}>
            {loginError}
          </Alert>
        )}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          color="primary"
          style={{ marginTop: 16 }}
        >
          {t('signIn')}
        </Button>
      </form>
    </>
  );
};

export default SignInForm;
